module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [(_vm.procedure) ? [_vm._v(_vm._s(_vm.$t('static.recipes.edit.editProcedure')))] : [_vm._v(_vm._s(_vm.$t('static.recipes.edit.addProcedure')))]], 2), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('v-form', {
    attrs: {
      "save": _vm.save,
      "form": _vm.form,
      "translation": "form.recipes",
      "hasLabel": true
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5547d78b","hasScoped":false}!./src/app/components/recipeProcedureModal/recipeProcedureModal.html
// module id = 3012
// module chunks = 1